import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import styled from 'styled-components';
import { IncomingCostTypes, OutgoingCostTypes } from '../../Invoices/constants';
import { BaseComponent } from '../../../components/BaseComponent';
import _ from 'lodash';
import { getPropByName } from '../../../utils/props';
import { Content } from '../../../components/Content';
import { FormField, FormFields } from '../../../components/FormFields';
import { HBox, VBox } from '../../../components/Box';
import { Dropdown } from '../../../components/Dropdown';
import { Checkbox } from '../../../components/Checkbox';
import DatePicker from 'react-datepicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { CompanySelection } from '../../Companies/components/CompanySelection';
import { VehicleSelection } from '../../Invoices/components/VehicleSelection';
import { Input } from '../../../components/Form';
import { Button } from '../../../components/Buttons';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { selectCompany } from '../../Invoices/selectors';
import { calculateFinancialAmounts, createInvoice } from '../../Invoices/actions';
import { fetchCompany } from '../../Companies/actions';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import React from 'react';
import { formatLicensePlate } from '../../../utils/string';
import { makeSelectLocale } from '../../../containers/LanguageProvider/selectors';
import { translateCountry } from '../../Companies/translate-countries';

dayjs.extend(customParseFormat);

const Container = styled.div``;

const Address = styled.div`
  border: ${props => (!!props.isActive ? '1px solid rgb(21, 172, 121)' : '1px solid grey')};
  border-radius: 6px;
  padding: 12px;
  width: calc(33% - 10px);
  margin: 6px 0;
  font-size: 12px;

  @media (max-width: 768px) {
    width: 100%;
  }

  .button {
    margin: 0 -12px;
  }
  .name {
    font-size: 12px;
  }
  .address {
    margin-top: 12px;
  }
`;

const DIRECTION_OPTIONS = [
  { label: 'outgoing', value: 'outgoing' },
  { label: 'incoming', value: 'incoming' },
];

const BTW_OPTIONS = [
  { label: 'Excl. BTW', value: 1 },
  { label: 'Incl. BTW', value: 0 },
];

const INCOMING_COSTS_OPTIONS = Object.values(IncomingCostTypes)?.map(cost => ({
  value: cost,
  label: cost.toLowerCase().replaceAll('_', ' '),
}));

const OUTGOING_COSTS_OPTIONS = Object.values(OutgoingCostTypes)?.map(cost => ({
  value: cost,
  label: cost.toLowerCase().replaceAll('_', ' '),
}));

const TRANSPORT_OPTIONS = [
  { label: 'pickup', value: 'pickup' },
  { label: 'deliver', value: 'deliver' },
];

const STATE = {
  direction: 'outgoing',
  selectedCompanyId: null,
  selectedCompanyLabel: null,
  editCompany: true,
  selectedTransport: null,
  selectedTransportLabel: '',
  releaseBeforeIncoming: false,
  releaseBeforeOutgoing: false,
  date: null,
  dueDate: null,
  selectedUserLabel: null,
  selectedUserId: null,
  selectedAddress: null,
  selectedVehicle: null,
  editVehicle: true,
  excludeBTW: 1,
  excludeBTWLabel: 'Excl. BTW',
  price: '',
  selectedCost: null,
  selectedCostLabel: '',
  addedCosts: [],
  addedCostsLabels: [],
  bpmValue: null,
  isFinal: false,
  financialTotalAmount: null,
  economicalTotalAmount: null,
  invoiceSubjects: [],
  // paidDate: null,
  // desiredDeliveryDate: null,
  // incoming: null,
  // payments: null,
  // creatorId: null,
  // creatorLabel: null,
  type: 'invoice',
  // typeLabel: null,
  // typeEdit: false,
  // selectedType: null,
  // selectedTypeLabel: null,
  // status: null,
  // statusLabel: null,
  // statusEdit: false,
  // selectedStatus: null,
  // selectedStatusLabel: null,
  // relationSources: [],
};

/* eslint-disable react/prefer-stateless-function */
class ProductInvoiceCreateComp extends BaseComponent {
  constructor(props) {
    super(props, { ..._.cloneDeep(STATE) });
  }

  onDateChange(value) {
    let date = dayjs(value).format('YYYY-MM-DD hh:mm:ss');
    this.updateState('date', date);
    return this;
  }

  onDueDateChange(value) {
    let date = dayjs(value).format('YYYY-MM-DD hh:mm:ss');
    this.updateState('dueDate', date);
    return this;
  }

  onPaidDateChange(value) {
    this.updateState('paidDate', value);
    return this;
  }

  onDesiredDeliveryDateChange(value) {
    this.updateState('desiredDeliveryDate', value);
    return this;
  }

  get locale() {
    return this.props.locale;
  }

  get dto() {
    return {
      separateInvoice: {
        date: this.state.date,
        direction: this.state.direction,
        //discount: this.state.discount,
        dueDate: this.state.dueDate,
        //desiredDeliveryDate: this.state.desiredDeliveryDate,
        // economicalTotalAmount: this.state.economicalTotalAmount,
        financialTotalAmount: this.state.financialTotalAmount,
        isFinal: this.state.isFinal,
        //paidDate: this.state.paidDate,
        //payments: this.state.payments,
        //incoming: this.state.incoming,
        // statusId: this.state.status,
        type: this.state.type ?? 'invoice',
        //userCreatorId: this.state.userCreatorId,
        incomingCompanyId: this.state.direction === 'incoming' ? this.state.selectedCompanyId : null,
        outgoingCompanyId: this.state.direction === 'outgoing' ? this.state.selectedCompanyId : null,
        transportLocationId: this.state?.selectedAddress?.id ?? null,
        transport: this.state.direction === 'incoming' ? this.state.selectedTransportLabel : null,
        release_before_incoming_transport: this.state.direction === 'incoming' ? this.state.releaseBeforeIncoming : null,
        release_before_outgoing_transport: this.state.direction === 'outgoing' ? this.state.releaseBeforeOutgoing : null,
      },
      invoiceSubjects: this.state.invoiceSubjects,
      relationSources: this.state.relationSources?.map(s => {
        return { description: s.description };
      }),
    };
  }

  onCreate() {
    console.log(this.dto);

    this.props.create(this.dto, result => {
      this.reset();
      this.to(`/invoices/${result.id}`);
    });
  }

  onIsFinalChanged() {
    this.setState(prev => {
      return { ...prev, isFinal: !prev.isFinal };
    });
  }

  reset() {
    this.setState(prev => {
      return { ...STATE, invoiceSubjects: STATE.invoiceSubjects, relationSources: STATE.relationSources };
    });
  }

  // updated methods
  setDirection = e => {
    const { value } = e;
    this.setState({
      direction: value,
    });
  };

  setExclBTW = e => {
    const { value, label } = e;
    this.setState({
      excludeBTW: value,
      excludeBTWLabel: label,
    });
  };

  toggleEditCompany = () => {
    this.setState({ editCompany: true });
  };

  toggleEditVehicle = () => {
    this.setState({ editVehicle: true });
  };

  onChangeCompanySelection(company) {
    this.setState(
      prev => ({
        ...prev,
        selectedCompanyLabel: company.label ?? '',
        selectedCompanyId: company.id,
        editCompany: false,
      }),
      this.props.fetchCompany(company.id, result => {
        if (result.id) {
          const defautltTransportType = getPropByName(result, 'prefence_incoming_transport');
          const defaultReleaseBeforeIncoming = getPropByName(result, 'release_before_incoming_transport');
          const defaultReleaseBeforeOutgoing = getPropByName(result, 'release_before_outgoing_transport');
          defautltTransportType
            ? this.setState({
                selectedTransport: defautltTransportType,
                selectedTransportLabel: defautltTransportType,
                defautltTransport: defautltTransportType,
              })
            : this.setState({
                selectedTransport: null,
                selectedTransportLabel: '',
                defautltTransport: '',
              });
          defaultReleaseBeforeIncoming
            ? this.setState({
                releaseBeforeIncoming: defaultReleaseBeforeIncoming,
              })
            : this.setState({ releaseBeforeIncoming: false });

          defaultReleaseBeforeOutgoing
            ? this.setState({
                releaseBeforeOutgoing: defaultReleaseBeforeOutgoing,
              })
            : this.setState({ releaseBeforeOutgoing: false });
        }
      }),
    );
  }

  selectTransportType = e => {
    this.setState({ selectedTransport: e.value, selectedTransportLabel: e.label });
  };

  onReleaseTransportChange() {
    this.state.direction === 'incoming'
      ? this.setState(prev => {
          return { ...prev, releaseBeforeIncoming: !prev.releaseBeforeIncoming };
        })
      : this.setState(prev => {
          return { ...prev, releaseBeforeOutgoing: !prev.releaseBeforeOutgoing };
        });
  }

  onChangeVehicle = vehicle => {
    console.log(vehicle);
    this.setState(
      prev => ({
        ...prev,
        selectedVehicle: vehicle,
        editVehicle: false,
      }),
      () => {
        this.addInvoiceSubject('vehicle');
        this.addInvoiceSubject('BPM');
      },
    );
  };

  setCompanyUser = e => {
    this.setState({ selectedUserId: e.value, selectedUserLabel: e.label });
  };

  getUserOptions = () => {
    return this.props.fetchedCompany?.users?.map(user => {
      const name = user.properties?.find(p => p?.name?.name === 'name')?.value;
      const surname = user.properties?.find(p => p?.name?.name === 'surname')?.value;
      const fullName = name && surname ? `${name} ${surname}` : user?.email_address;
      return { value: user.id, label: fullName };
    });
  };

  handleSetAddress = address => {
    this.setState({ selectedAddress: address });
  };

  timeout(fn, ms, clear) {
    if (clear) clearTimeout(clear);
    let t = setTimeout(fn, ms);
    this._timeouts.push(t);
    return t;
  }

  onPriceChange = e => {
    const { value } = e.target;
    this.setState({ price: +value });
    this._t = this.timeout(this.calculateAmounts('vehicle', value), 300, this._t);
  };

  sanitizeValue(raw) {
    return raw === '' ? null : raw;
  }

  addInvoiceSubject = (type, costType) => {
    if (!this.state.selectedVehicle) return;
    const basicSubject = {
      type,
    };
    if (type === 'BPM') {
      basicSubject.description = 'BPM';
    }
    if (type === 'cost') {
      basicSubject.costType = costType;
      let _description = costType.toLowerCase().replaceAll('_', ' ');
      basicSubject.description = _description[0].toUpperCase() + _description.slice(1);
    }
    if (type === 'vehicle') {
      basicSubject.tax_type = this.state.selectedVehicle?.tax_type;
      basicSubject.vehicleId = this.state.selectedVehicle?.id;
    }
    console.log(basicSubject);
    if (this.state.invoiceSubjects?.length && type === 'vehicle') {
      this.setState(prev => ({ ...prev, invoiceSubjects: prev.invoiceSubjects.splice(0, 1, { ...basicSubject }) }));
    } else {
      this.setState(prev => ({ ...prev, invoiceSubjects: [...prev.invoiceSubjects, { ...basicSubject }] }));
    }
  };

  removeInvoiceSubject = (type, costType) => {
    const updated = this.state.invoiceSubjects.filter(is => is?.type !== type && is?.costType !== costType);
    const financialTotalAmount = updated.reduce((total, subject) => {
      total += +subject.price ?? 0;
      return total;
    }, 0);
    this.setState({ invocesSubjects: [...updated], financialTotalAmount });
  };

  calculateAmounts = (type, rawValue, cost_type) => {
    const { selectedVehicle, direction, excludeBTW, selectedCompanyId } = this.state;
    const value = !rawValue ? 0 : +rawValue;

    const subject = {
      subject_type: type,
      direction,
      salesAmounts: {},
      financialAmounts: {},
      incomingCompanyId: null,
      outgoingCompanyId: null,
    };

    if (type === 'vehicle') {
      subject.vehicleId = selectedVehicle?.id;

      if (direction === 'outgoing') {
        subject.outgoingCompanyId = selectedCompanyId;

        if (!!excludeBTW && selectedVehicle?.tax_type === 'BTW') {
          subject.salesAmounts.financial_price_excl_vat_excl_bpm = value;
        }
        if (!excludeBTW && selectedVehicle?.tax_type === 'BTW') {
          subject.salesAmounts.financial_price_incl_vat_bpm = value;
        }
        if (!!excludeBTW && selectedVehicle?.tax_type === 'marge') {
          subject.salesAmounts.financial_price_marge_excl_bpm = value;
        }
        if (!excludeBTW && selectedVehicle?.tax_type === 'marge') {
          subject.salesAmounts.financial_price_marge_bpm = value;
        }
      } else {
        subject.incomingCompanyId = selectedCompanyId;
        if (!!excludeBTW && selectedVehicle?.tax_type === 'BTW') {
          subject.financialAmounts.financial_price_excl_vat_excl_bpm = value;
        }
        if (!excludeBTW && selectedVehicle?.tax_type === 'BTW') {
          subject.financialAmounts.financial_price_incl_vat_bpm = value;
        }
        if (!!excludeBTW && selectedVehicle?.tax_type === 'marge') {
          subject.financialAmounts.financial_price_marge_excl_bpm = value;
        }
        if (!excludeBTW && selectedVehicle?.tax_type === 'marge') {
          subject.financialAmounts.financial_price_marge_bpm = value;
        }
      }
    } else if (type === 'cost') {
      if (direction === 'outgoing') {
        subject.outgoingCompanyId = selectedCompanyId;

        if (!!excludeBTW) {
          subject.salesAmounts.cost_price_excl_vat = value;
        } else {
          subject.salesAmounts.cost_price_incl_vat = value;
        }
      } else {
        subject.incomingCompanyId = selectedCompanyId;
        if (!!excludeBTW) {
          subject.financialAmounts.cost_price_excl_vat = value;
        } else {
          subject.financialAmounts.cost_price_incl_vat = value;
        }
      }
    } else if (type === 'BPM') {
      if (direction === 'outgoing') {
        subject.outgoingCompanyId = selectedCompanyId;

        if (!!excludeBTW) {
          subject.salesAmounts.bpm_price_excl_vat = value;
        } else {
          subject.salesAmounts.bpm_price_incl_vat = value;
        }
      } else {
        subject.incomingCompanyId = selectedCompanyId;
        if (!!excludeBTW) {
          subject.financialAmounts.bpm_price_excl_vat = value;
        } else {
          subject.financialAmounts.bpm_price_incl_vat = value;
        }
      }
    }
    this.props.calculateFinancialAmounts(subject, result => {
      console.log(result);
      // if (result?.id) {
      //   delete result.id;
      // }
      //
      // if (result?.invoiceId) {
      //   delete result?.invoiceId;
      // }
      //
      // if (result?.subjectVat?.id) {
      //   delete result.subjectVat.id;
      // }
      if (type !== 'vehicle') {
        delete result?.description;
      }

      const updatedSubjects = [...this.state.invoiceSubjects];

      const positionToUpdate = cost_type
        ? updatedSubjects.findIndex(sub => sub?.costType === cost_type)
        : updatedSubjects.findIndex(sub => sub?.type === type);
      console.log('subject pos: ', positionToUpdate);
      if (positionToUpdate >= 0) {
        updatedSubjects[positionToUpdate] = { ...updatedSubjects[positionToUpdate], ...result };
        const updatedTotal = updatedSubjects.reduce((total, subject) => {
          if (!!subject.price) {
            total += subject.price;
          }
          return total;
        }, 0);
        this.setState({ invoiceSubjects: [...updatedSubjects], financialTotalAmount: updatedTotal });
      }
    });
  };

  selectCost = e => {
    this.setState({ selectedCost: e.value, selectedCostLabel: e.label });
  };

  addCost = () => {
    if (!this.state.selectedCost || !this.state.selectedCostLabel) return;
    const newCostType = this.state.selectedCost;
    this.setState(
      prev => ({
        ...prev,
        addedCosts: [...prev.addedCosts, { type: prev.selectedCost, value: 0 }],
        addedCostsLabels: [...prev.addedCostsLabels, prev.selectedCostLabel],
        selectedCost: null,
        selectedCostLabel: '',
      }),
      this.addInvoiceSubject('cost', newCostType),
    );
  };

  removeCost = idx => {
    this.removeInvoiceSubject('cost', this.state.addedCostsLabels[idx]);
    this.setState(prev => ({
      ...prev,
      addedCosts: prev.addedCosts.filter((c, i) => i !== idx),
      addedCostsLabels: prev.addedCostsLabels.filter((c, i) => i !== idx),
    }));
  };

  onCostChange = (e, idx) => {
    const { value } = e.target;
    const updatedCosts = [...this.state.addedCosts];
    updatedCosts[idx].value = value;
    this.setState({ addedCosts: [...updatedCosts] });
    this._t = this.timeout(this.calculateAmounts('cost', value, this.state.addedCosts[idx].type), 300, this._t);
  };

  onBpmChange = e => {
    const { value } = e.target;
    this.setState({ bpmValue: value });
    this._t = this.timeout(this.calculateAmounts('BPM', value), 300, this._t);
  };

  render() {
    const propVal = name =>
      this.state.selectedVehicle?.properties?.find(p => p.propertyName.name === name)?.propertyValue.value || '';

    const EURFormat = new Intl.NumberFormat('nl-NL', {
      style: 'currency',
      currency: 'EUR',
    }).format;

    let costsOptions = this.state.direction === 'outgoing' ? OUTGOING_COSTS_OPTIONS : INCOMING_COSTS_OPTIONS;
    costsOptions = costsOptions.filter(cost => !this.state.addedCostsLabels.includes(cost?.label));

    return (
      <Container>
        <h3>{this.lbl('invoice.create.title')}</h3>
        <Content>
          <FormFields>
            <HBox flip={window.innerWidth <= 768} vCenter spaceAround>
              <VBox left style={{ maxWidth: 225, marginBottom: 10 }}>
                {this.lbl('invoice.create.direction')}
                <Dropdown options={DIRECTION_OPTIONS} value={this.state.direction} onChange={this.setDirection} />
              </VBox>
              <VBox left style={{ maxWidth: 225 }}>
                {this.lbl('invoice.create.finalized')}
                <Checkbox checked={this.state.isFinal} onChange={this.onIsFinalChanged.bind(this)}></Checkbox>
              </VBox>
            </HBox>
            <HBox flip={window.innerWidth <= 768} vCenter spaceAround>
              <VBox left style={{ maxWidth: 225 }}>
                {this.lbl('invoice.create.date')}
                <FormField>
                  <DatePicker
                    dateFormat="dd-MM-yyyy"
                    selected={this.state.date && dayjs(this.state.date).toDate()}
                    onChange={this.onDateChange.bind(this)}
                  />
                </FormField>
              </VBox>
              <VBox left style={{ maxWidth: 225 }}>
                {this.lbl('invoice.create.dueDate')}
                <FormField>
                  <DatePicker
                    dateFormat="dd-MM-yyyy"
                    selected={this.state.dueDate && dayjs(this.state.dueDate).toDate()}
                    onChange={this.onDueDateChange.bind(this)}
                  />
                </FormField>
              </VBox>
            </HBox>
            <HBox flip={window.innerWidth <= 768} vCenter spaceAround>
              <VBox left style={{ maxWidth: 225 }}>
                <HBox vCenter>
                  <span>
                    <span style={{ textTransform: 'capitalize' }}>{this.state.direction}</span> company
                  </span>
                  <FontAwesomeIcon icon={faEdit} style={{ width: 20, marginLeft: 5 }} onClick={this.toggleEditCompany} />
                </HBox>
                {this.state.editCompany || !this.state.selectedCompanyId ? (
                  <CompanySelection
                    order
                    user={{ id: this.state.selectedCompanyId }}
                    onSelect={this.onChangeCompanySelection.bind(this)}
                  />
                ) : (
                  <div style={{ width: '100%' }}>{this.state.selectedCompanyLabel}</div>
                )}
              </VBox>

              <VBox left style={{ maxWidth: 225 }}>
                <span>Company contact</span>
                {this.state.selectedCompanyId ? (
                  <Dropdown
                    onChange={this.setCompanyUser}
                    value={this.state.selectedUserLabel ?? ''}
                    options={this.getUserOptions() ?? []}
                  />
                ) : (
                  <span>You need to choose company first</span>
                )}
              </VBox>
            </HBox>
            {!!this.state.selectedCompanyId && !!this.props.fetchedCompany && (
              <HBox
                left
                flexWrap
                flip={window.innerWidth < 768}
                style={{ gap: 10, padding: 24, border: '1px solid grey', margin: 24 }}
                className={'address-block'}
              >
                {this.props.fetchedCompany?.addresses?.map(address => (
                  <Address
                    key={`${address?.id}`}
                    onClick={() => this.handleSetAddress(address)}
                    isActive={this.state.selectedAddress?.id === address?.id}
                  >
                    <VBox left>
                      <HBox vCenter>
                        <h3 className="name">{address?.name}</h3>
                        <Checkbox checked={this.state.selectedAddress?.id === address?.id} />
                      </HBox>
                      <VBox className="address" left>
                        <div>{address?.addressLine1}</div>
                        <div>
                          {address?.postcode} {address?.city}
                        </div>
                        <div>{translateCountry(address.country?.name, this.locale)}</div>
                      </VBox>
                    </VBox>
                  </Address>
                ))}
              </HBox>
            )}
            {/* select vehicle */}
            {!!this.state.selectedCompanyId && (
              <HBox flip={window.innerWidth <= 768} vCenter spaceAround>
                <VBox left style={{ maxWidth: 225 }}>
                  <HBox left>
                    {this.state.direction == 'incoming' && (
                      <VBox left>
                        <span>Transport</span>
                        <Dropdown
                          options={TRANSPORT_OPTIONS}
                          value={this.state.defautltTransport || this.state.selectedTransportLabel}
                          onChange={this.selectTransportType}
                        />
                        <VBox left style={{ maxWidth: 225 }}>
                          {this.lbl('invoice.create.release_before_incoming_transport')}
                          <Checkbox
                            checked={this.state.releaseBeforeIncoming}
                            onChange={this.onReleaseTransportChange.bind(this)}
                          ></Checkbox>
                        </VBox>
                      </VBox>
                    )}
                    {this.state.direction === 'outgoing' && (
                      <VBox left>
                        <VBox left style={{ maxWidth: 225 }}>
                          {this.lbl('invoice.create.release_before_outgoing_transport')}
                          <Checkbox
                            checked={this.state.releaseBeforeOutgoing}
                            onChange={this.onReleaseTransportChange.bind(this)}
                          ></Checkbox>
                        </VBox>
                      </VBox>
                    )}
                  </HBox>
                  <HBox vCenter>
                    <span>Vehicle</span>
                    <FontAwesomeIcon icon={faEdit} style={{ width: 20, marginLeft: 5 }} onClick={this.toggleEditVehicle} />
                  </HBox>
                  {!this.state.selectedVehicle || !!this.state.editVehicle ? (
                    <VehicleSelection onSelect={this.onChangeVehicle} />
                  ) : (
                    <div>
                      {this.state.selectedVehicle?.brand_name
                        ? `${this.state.selectedVehicle?.brand_name} ${this.state.selectedVehicle?.model_name}`
                        : this.state.selectedVehicle.id}
                    </div>
                  )}
                </VBox>
                {this.state.selectedVehicle && (
                  <VBox left style={{ maxWidth: 300 }}>
                    <HBox vCenter>
                      <strong>Regplate:</strong>
                      <span>{propVal('regplate') ? formatLicensePlate(propVal('regplate')) : ''}</span>
                    </HBox>
                    <HBox vCenter>
                      <strong>VIN:</strong>
                      <span>{propVal('vin')}</span>
                    </HBox>
                    <HBox vCenter>
                      <strong>Brand & model:</strong>
                      <div>
                        <span>{`${propVal('brand_name')} ${propVal('model_name')}`}</span>
                        <span>{propVal('model_info')}</span>
                      </div>
                    </HBox>
                    <HBox vCenter>
                      <strong>Date first all.:</strong>
                      <span>{propVal('date_first_allowance')}</span>
                    </HBox>
                    <HBox vCenter>
                      <strong>Mileage:</strong>
                      <span>{propVal('mileage') + ' km'}</span>
                    </HBox>
                    <HBox vCenter>
                      <strong>Color:</strong>
                      <span>{propVal('base_color')}</span>
                    </HBox>
                  </VBox>
                )}
              </HBox>
            )}

            {this.state.selectedVehicle?.id && (
              <HBox spaceAround flip={window.innerWidth <= 768} style={{ marginTop: 20 }}>
                <VBox left style={{ maxWidth: 225 }}>
                  <span>BTW</span>
                  <Dropdown options={BTW_OPTIONS} value={this.state.excludeBTWLabel ?? ''} onChange={this.setExclBTW} />
                  <HBox vCenter left>
                    <FormField label="Price: ">
                      <Input
                        name="price"
                        type="number"
                        step="0.01"
                        min="0.00"
                        value={this.state.price}
                        onChange={this.onPriceChange}
                      />
                    </FormField>
                  </HBox>
                  <HBox vCenter left>
                    <FormField label="BPM: ">
                      <Input
                        name="bpm"
                        type="number"
                        step="0.01"
                        min="0.00"
                        readonly
                        value={this.state.bpmValue ?? ''}
                        onChange={this.onBpmChange}
                      />
                    </FormField>
                  </HBox>
                </VBox>
                <VBox left style={{ maxWidth: 225 }}>
                  <HBox vCenter>
                    <VBox left>
                      <span>Costs:</span>
                      <Dropdown options={costsOptions} value={this.state.selectedCostLabel} onChange={this.selectCost} />
                    </VBox>
                    <Button small onClick={this.addCost}>
                      Add
                    </Button>
                  </HBox>
                  {this.state.addedCostsLabels?.map((cost, idx) => (
                    <HBox vCenter spaceAround flip={window.innerWidth <= 768} style={{ maxWidth: 350 }} key={cost}>
                      <FormField label={cost}>
                        <Input
                          name={cost}
                          type="number"
                          step="0.01"
                          min="0.00"
                          value={this.state.addedCosts[idx]?.value}
                          onChange={e => this.onCostChange(e, idx)}
                        />
                        <Button small warning onClick={() => this.removeCost(idx)}>
                          Delete
                        </Button>
                      </FormField>
                    </HBox>
                  ))}
                </VBox>
              </HBox>
            )}
            {!!this.state.financialTotalAmount && (
              <HBox vCenter>
                <VBox left style={{ maxWidth: 350 }}></VBox>
              </HBox>
            )}

            {!!this.state.financialTotalAmount && (
              <HBox>
                <VBox left style={{ maxWidth: 350 }}>
                  <HBox vCenter>
                    <div>
                      <strong>Total:</strong>
                    </div>
                    <div>{EURFormat(this.state.financialTotalAmount)}</div>
                  </HBox>
                </VBox>
              </HBox>
            )}
          </FormFields>
        </Content>
        <HBox>
          <Button primary onClick={this.reset.bind(this)}>
            {this.lbl('invoice.create.reset')}
          </Button>
          <Button primary disabled={false} onClick={this.onCreate.bind(this)}>
            {this.lbl('invoice.create.createBtn')}
          </Button>
        </HBox>
      </Container>
    );
  }
}

ProductInvoiceCreateComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    fetchedCompany: selectCompany(),
    locale: makeSelectLocale(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    create(dto, callback) {
      dispatch(createInvoice(dto, callback));
    },
    fetchCompany(companyId, callback) {
      dispatch(fetchCompany(companyId, callback));
    },
    calculateFinancialAmounts(subject, callback) {
      dispatch(calculateFinancialAmounts(subject, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const ProductInvoiceCreate = compose(withConnect, withRouter)(ProductInvoiceCreateComp);
